import axios from "axios";

// Centralized axios instance with credentials for the cookie-based auth flow.
const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const API = API_BASE;
export const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;
